import React from 'react';
import { FiTrendingDown } from 'react-icons/fi';
import { formatMoney } from '../utils/money';
import { scoreBadgeClasses, scoreTone } from '../utils/collectionScore';

export default function ClientRiskAlertPanel({
  clients = [],
  lookbackDays = 14,
  modoOscuro,
  box,
  textPri,
  textMuted,
  onSelectClient,
  compact = false,
}) {
  if (!clients.length) return null;

  const border = modoOscuro ? 'border-red-900/50 bg-red-950/20' : 'border-red-200 bg-red-50/80';

  return (
    <section className={`rounded-2xl border p-4 ${border} ${box}`}>
      <div className="flex items-start gap-3">
        <span
          className={`shrink-0 p-2 rounded-xl ${
            modoOscuro ? 'bg-red-900/40 text-red-300' : 'bg-red-100 text-red-700'
          }`}
        >
          <FiTrendingDown className="w-5 h-5" />
        </span>
        <div className="min-w-0 flex-1">
          <h2 className={`text-sm font-semibold ${textPri}`}>
            {clients.length === 1
              ? 'Cliente en riesgo (score en caída)'
              : `${clients.length} clientes en riesgo`}
          </h2>
          <p className={`text-xs mt-0.5 ${textMuted}`}>
            Comparación vs hace {lookbackDays} días — priorizá seguimiento antes de que empeore la mora.
          </p>
          <ul className={`mt-3 space-y-2 ${compact ? 'max-h-40 overflow-y-auto pr-1' : ''}`}>
            {clients.map((c) => (
              <li key={c.cliente}>
                <button
                  type="button"
                  onClick={() => onSelectClient?.(c.cliente)}
                  className={`w-full text-left rounded-xl border px-3 py-2.5 transition-colors ${
                    modoOscuro
                      ? 'border-red-900/40 bg-gray-900/40 hover:bg-gray-900/70'
                      : 'border-red-100 bg-white hover:bg-red-50/50'
                  } ${onSelectClient ? 'cursor-pointer' : 'cursor-default'}`}
                >
                  <div className="flex flex-wrap items-center justify-between gap-2">
                    <span className={`text-sm font-semibold truncate ${textPri}`}>{c.cliente}</span>
                    <span
                      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-lg text-[10px] font-bold ${scoreBadgeClasses(scoreTone(c.score), modoOscuro)}`}
                    >
                      {c.previousScore}
                      <span className="opacity-60">→</span>
                      {c.score}
                    </span>
                  </div>
                  <p className={`text-[11px] mt-1 ${textMuted}`}>{c.reason}</p>
                  {!compact && c.pendienteArs > 0 && (
                    <p className={`text-[11px] mt-0.5 tabular-nums ${textMuted}`}>
                      Pendiente {formatMoney(c.pendienteArs, 'ARS')}
                      {c.impagas > 0 ? ` · ${c.impagas} impaga(s)` : ''}
                    </p>
                  )}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
